import {
  AppBar,
  CssBaseline,
  Drawer,
  Toolbar,
  Typography,
  Box,
  IconButton,
  LinearProgress
} from '@mui/material';
import { MenuRounded, Person} from '@mui/icons-material';
import React, { useEffect, useState, useCallback } from 'react';
import Utilities from '../../util/Utilities';
import strings from '../../values/strings/strings';
import colors from '../../values/colors';
import DashboardDrawerList from './DashboardDrawerList';
import MenuList from './MenuList';
import { useHistory } from 'react-router';
import AuthPerformLogout from '../../usecases/AuthPerformLogout';
import AuthCheckLogin from '../../usecases/AuthCheckLogin';
import Pages from '../../pages/Pages';
import CacheLoadCredentials from '../../usecases/CacheLoadCredentials';
import DashboardDrawerListCLI from './DashboardDrawerListCLI';
import APIConstants from '../../connection/APIConstants';
import { useLocation } from 'react-router-dom';

const drawerWidth = 240;

/*
  DashboardFrame is the main comoponent of dashboard pages, 
  including menu and app bar.
  Its children is the page to be displayed 
  props are
  - onUserData(): 
    the DashboardFrame get the user data and check its authentication, 
    it can be delivered back to the page component
    who use DashboardFrame through this function
          
*/
  
  function DashboardFrame(props) {  
    const history = useHistory();
    const { window: containerWindow, hideDrawer } = props;
    const [mobileOpen, setMobileOpen] = useState(false);
    const [user, setUser] = useState({});
    const [drawer, setDrawer] = useState(null);
    const location = useLocation();
    const toolRoute = location.pathname === Pages.routes.Tools;
    
    const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen);
    };
  
    const logout = useCallback(async (login) => {
      await AuthPerformLogout()
      if(login) history.push(Pages.routes.Login)
      else history.push(Pages.routes.HomePage)    
    }, [history]);
  
    useEffect(() => {
      //Start Funcion to be executed when this Component calls the useEffect empty
      const start = async () => {
        //Check if there is a user is authorized, if not logout
        let userData = await AuthCheckLogin().catch(e =>{console.error(e); return null})
        if(!userData && !toolRoute){
          logout(true)
        }
        else {
          setUser(userData)
        }
      }
      //Close function to be executed when this Component finishes
      const close = () => {
        //Run when application closes      
      } 
  
      start()
      return close   
    }, [logout])

    useEffect(() => {
      const onSessionUpdated = (event) => {
        if (event.detail) {
          setUser(event.detail);
          return;
        }
        CacheLoadCredentials().then((data) => {
          if (data) setUser(data);
        });
      };
      window.addEventListener('saframanager-session-updated', onSessionUpdated);
      return () => window.removeEventListener('saframanager-session-updated', onSessionUpdated);
    }, [])
  
    useEffect(() => {
      if(props.onUserData)props.onUserData(user)        
    }, [props, user])                 

  useEffect(() => {
    CacheLoadCredentials().then(res => {
      if (res && res.tipo) { 
        if(user && user.tipo === APIConstants.user_type_cli) {
          setDrawer((
            <div>
              <Typography variant="h5" color="primary" align="center" style={{padding: 20}}>{Utilities.todasMaiusculas(strings.getString('app_name'))}</Typography>
              <DashboardDrawerListCLI />
            </div>
          ));
        // }  else if (!user && user.tipo === APIConstants.user_type_cli && toolRoute ) {
          
            // <div>
            //   <Typography variant="h5" color="primary" align="center" style={{padding: 20}}>{Utilities.todasMaiusculas(strings.getString('app_name'))}</Typography>
            // </div>

        }
        if (user && user.tipo === APIConstants.user_type_dev) {
          setDrawer((
            <div>
              <Typography variant="h5" color="primary" align="center" style={{padding: 20}}>{Utilities.todasMaiusculas(strings.getString('app_name'))}</Typography>
              <DashboardDrawerList />
            </div>
          ));
        }
      }  
    });

  }, [user, toolRoute]);
  
  const showAppBar = user && Object.keys(user).length > 0 || !toolRoute;

  const userMenuItems = [
    {value: strings.getString('screen_profile_title'), onClick: () => {history.push(Pages.routes.Profile)}},
    {value: strings.getString('info_logout'), onClick: logout},
  ];

  const container = typeof containerWindow === 'function'
    ? () => containerWindow().document.body
    : undefined;
      
  return (
    
    <Box sx={{ display: 'flex', width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      <CssBaseline />
      { showAppBar && (
      <AppBar
        position="fixed"
        sx={{
          width: { xs: '100%', sm: `calc(100% - ${drawerWidth}px)` },
          maxWidth: '100%',
          ml: { sm: `${drawerWidth}px` },
          overflow: 'hidden',
          boxSizing: 'border-box',
        }}
        elevation={0}
        style={{backgroundColor: colors.getTheme().palette.background.default,}}
      >
        <Toolbar
          sx={{
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            justifyContent: { xs: 'flex-start', sm: 'flex-start' },
            gap: { xs: 1, sm: 0 },
            py: { xs: 1, sm: 0 },
            px: { xs: 1.5, sm: 2 },
            minWidth: 0,
            maxWidth: '100%',
            boxSizing: 'border-box',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              minWidth: 0,
              gap: 1,
            }}
          >
            {!hideDrawer && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerToggle}
                sx={{ display: { sm: 'none' }, flexShrink: 0 }}
              >
                <MenuRounded />
              </IconButton>
            )}
            <Typography
              variant="h6"
              color="primary1"
              sx={{
                flex: 1,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {props.title}
            </Typography>
            <Box sx={{ display: { xs: 'none', sm: 'block' }, flexShrink: 0, maxWidth: 220 }}>
              <MenuList value={user.nome} endIcon={<Person/>} items={userMenuItems}/>
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: 'flex', sm: 'none' },
              width: '100%',
              minWidth: 0,
              pl: !hideDrawer ? 0 : 0,
              boxSizing: 'border-box',
            }}
          >
            <MenuList value={user.nome} endIcon={<Person/>} items={userMenuItems}/>
          </Box>
        </Toolbar>      
      {props.loading && <LinearProgress />}
      </AppBar>
      )}
        { !hideDrawer && (
      <Box
        component="nav"
        sx={{
          width: { xs: 0, sm: drawerWidth },
          flexShrink: { sm: 0 },
          display: { xs: 'contents', sm: 'block' },
        }}
        aria-label="mailbox folders"
      >
          
          <Drawer container={container} variant="temporary" open={mobileOpen} onClose={handleDrawerToggle} ModalProps={{keepMounted: true, }}
            sx={{ display: { xs: 'block', sm: 'none' }, '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },}} >
            {drawer}
          </Drawer>
          <Drawer variant="permanent" sx={{ display: { xs: 'none', sm: 'block' }, '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth }, }} open>
            {drawer}
          </Drawer>
      </Box>
        )}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            flexBasis: 0,
            p: { xs: 2, sm: 3 },
            width: { xs: 'auto', sm: hideDrawer ? '100%' : `calc(100% - ${drawerWidth}px)` },
            maxWidth: '100%',
            minWidth: 0,
            boxSizing: 'border-box',
            overflowX: 'hidden',
          }}
        >
          {/* Spacer matching AppBar height (taller on mobile because user menu stacks) */}
          <Toolbar sx={{ display: { xs: 'none', sm: 'flex' } }} />
          <Box sx={{ display: { xs: 'block', sm: 'none' }, height: 112 }} />
          <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0, overflowX: 'hidden' }}>
            {props.children}
          </Box>
        </Box>
    </Box>

  );
}

export default DashboardFrame;
